import { Route, Routes } from 'react-router-dom';
import AppLayout from './app-layout';
import IndexPage from '@/app/index';
import CodesPage from '@/app/codes/index';
import CodeDetailPage from '@/app/codes/code-details';
import CodeRestorePage from '@/app/codes/code-restore';
import CreateCodePage from '@/app/create-code/index';
import FreeTextPage from '@/app/create-free-text-code/index';
import StatsPage from '@/app/stats/index';
import AboutPage from '@/app/about/index';
import ContactPage from '@/app/contact/index';

const NotFound = () => (
  <div className="flex items-center justify-center h-full">
    <h1 className="text-2xl font-bold">404 – Page not found</h1>
  </div>
);

export default function Router() {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route index element={<IndexPage />} />
        <Route path="/create-code" element={<CreateCodePage />} />
        <Route path="/create-free-text-code" element={<FreeTextPage />} />
        <Route path="/codes" element={<CodesPage />} />
        <Route path="/codes/:slug" element={<CodeDetailPage />} />
        <Route path="/codes/:slug/restore" element={<CodeRestorePage />} />
        <Route path="/stats/:slug" element={<StatsPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
